<template>
  <div>
    <Table border ref="tableSelection" :columns="columns4" :data="data1" @on-selection-change="submitSelection"></Table>
    <!--     <Button @click="handleSelectAll(true)">Set all selected</Button>
    <Button @click="handleSelectAll(false)">Cancel all selected</Button> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store'
export default {
  name: 'RelatedFile',
  data() {
    return {
      columns4: [],
      data1: [],
      tableType: 0,
    }
  },
  inject: ['CreatePage'],
  computed: {
    ...mapGetters(['sta'])
  },
  methods: {
    ...mapActions(['handleSetUserLogout', 'handleSetBookHistoryFiles', 'handleRemoveBookHistoryFiles']),
    onSelect(arg) {

    },
    handleSelectAll(status) {
      console.log("自动全选...")
      //console.log(this.$refs.tableSelection)
      this.$refs.tableSelection.selectAll(status);
      //this.$refs.tableSelection.selectAll(true);
    },
    showDeleted(sliders) {
      // var list=this.getSelected()
      // var list=sliders

    },
    getSelected() {
      return this.$refs.tableSelection.getSelection()
    },
    submitSelection() {
     // if (this.tableType === 1 || this.tableType === 2) {
        console.log("submitSelection...")
        let files = this.getSelected()
        store.commit('setBookSelectedFiles', files)
        console.log(store.state.user.workbook.readfilesSelected)
       // }

    },
    bindFiles() {
      let files = store.state.user.workbook.readfiles
      //console.log(files)
      this.bindData(files, 1)
    },
    bindData(sliders, editorType) {
      //console.log(sliders)
      this.columns4 = this.mockHeader(editorType)
      var mockTable = this.createTable(sliders)
      this.data1 = mockTable
      this.$emit("bindcomplete")
      //console.log(this.data1)
    },

    bindDownLoadFiles(files) {
      console.log("bindDownLoadFiles...")
      console.log(files)
      this.bindData(files, 4)
    },

    mounted() {
      //this.handleSelectAll(true)

    },
    add(fid, orderid, filename) {
      this.CreatePage(fid, orderid, filename);
    },
    createTable(sliders) {
      let da = []
      let items = sliders
      for (var i = 0; i < items.length; i++) {
        da.push({
          fileid: items[i].fileid,
          filename: items[i].filename,
          index: items[i].index,
          key: items[i].key,
          bookid:items[i].bookid===undefined?0:items[i].bookid,
          _checked: this.tableType===1 || this.tableType==2?false:true,
        })
      }
      //console.log(da)
      return da
    },
    mockHeader(editorType) {
      this.tableType = editorType
      //console.log(editorType)
      let arr = []
      let newbook = [{
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '文件名',
          key: 'filename'
        }
      ]
      let edithistory = [{
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '文件名',
          key: 'filename',
          render: (h, params) => {
            const row = params.row
            const text = row.filename
            const fileid = row.fileid
            return h('a', {
              on: {
                'click': () => {
                  this.add(fileid, 1, text);
                }
              }
            }, text);
          }
        },
        {
          title: '删除',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            // const fileid = row.fileid;
            return h('div', [h('Button', {
              props: {
                type: 'error',
                size: 'small',
                icon: 'md-trash',
              },
              on: {
                click: () => {
                  this.remove(row)
                }
              }
            }, '删除')]);
          }
        }
      ]

      let WorkBookShow = [{
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '文件名',
          key: 'filename',
          render: (h, params) => {
            const row = params.row
            const text = row.filename
            const fileid = row.fileid
            return h('a', {
              on: {
                'click': () => {
                  this.add(fileid, 1, text);
                }
              }
            }, text);
          }
        },
      ]

      let downloadbooklist = [{
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '文件名',
          key: 'filename'
        }
      ]

      if (editorType === 1) {
        arr = newbook
      } else if (editorType === 2) {
        arr = edithistory
      } else if (editorType === 3) {
        arr = WorkBookShow
      } else if (editorType === 4) {
        arr = downloadbooklist
      }else {
        arr = newbook
      }
      return arr
    },
    remove(row) {
      //console.log(row)
      // var selectrow={
      //     fileid: row.fileid,
      //     filename: row.filename,
      //     index: row.index,
      //     key: row.key
      //   }
      this.handleRemoveBookHistoryFiles(row)
      this.$emit('u-remove-row', row)
    }
  }
}

</script>
<style>
</style>
